import { useState, useEffect, useContext } from "react";
import UserContext from "../../../../contexts/UserContext";
import restService from "../../../../restService";
import CampaignContext from "../../../../contexts/CampaignContext";

import RemoveMember from "./remove-member";
import InviteMember from "./invite-member";
import UpdateMemberRole from "./update-role";
import { getMembers } from "../../../../lib";

const Roles = () => {
  const [user] = useContext(UserContext);
  const [campaign] = useContext(CampaignContext);

  const [open, setOpen] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const [removingMember, setRemovingMember] = useState(false);
  const [memberToRemove, setMemberToRemove] = useState({});

  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [selectedUserAndRole, setSelectedUserAndRole] = useState(null);

  const onClose = (callback) => {
    setOpen(false);
    setRemoveModal(false);
    setMemberToRemove("");

    if (callback && typeof callback === "function") {
      callback(); // optional callback to be called after closing the modal
    }
  };

  useEffect(() => {
    getCampaignMembers();
  }, [campaign]);

  const getCampaignMembers = async () => {
    try {
      const campaignMembers = await getMembers(campaign, user);

      setMembers(campaignMembers);
    } catch (error) {
      console.log(error);
    }
  };

  // remove member
  const handleRemoveMember = async (member) => {
    setRemovingMember(true);
    try {
      const {
        data: { message },
      } = await restService.Settings.deleteMember(
        campaign.id,
        member.id,
        user.accessToken
      );

      getCampaignMembers();
      onClose();
    } catch (error) {
      console.log(error);
    } finally {
      onClose();
      setRemovingMember(false);
    }
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="p-[36px] bg-white rounded shadow">
        <p>Admins</p>

        <div className="flex md:justify-between md:flex-row flex-col mt-7 md:mt-0 gap-7 md:gap-0 md:items-center">
          <div className="flex gap-3 items-center mt-2">
            <div className="">
              <div
                // type="button"
                // id="logout-button"
                aria-expanded="true"
                aria-haspopup="true"
                className="w-7 flex  items-center justify-center h-7 capitalize rounded-full bg-[#fc450b] text-white text-sm cursor-pointer "
              >
                {
                  Object.keys(user).length &&
                  user?.username?.split(/\W+/).length > 1
                    ? user?.username?.split(" ")[0][0] +
                      user?.username?.split(" ")[1][0]
                    : user?.username?.split(" ")[0][0]
                  // ? user?.username?.split(" ")[0][0] +
                  //   user?.username?.split(" ")[1][0]
                  // : ""
                }
              </div>
            </div>
            <div className="">
              <p className=" text-sm text-[#787878]">{user.username}</p>
              {/* <p className="m-0 p-0 text-sm text-gray-400">Admin</p> */}
            </div>
          </div>

          <button
            onClick={() => {
              setRemoveModal(false);
              setOpen(true);
            }}
            className="bg-[#3989DD] hover:bg-[#3277c0] transition-all py-2 px-5 text-white rounded"
          >
            Invite Members
          </button>
        </div>
      </div>

      <div className="bg-white w-full h-full rounded shadow">
        <table className=" w-full">
          <thead className="bg-[#F4F4F4] rounded h-14 w-full">
            <tr className="w-full">
              <th className=" w-2/4 text-left text-sm pl-6 text-[#24211D]">
                Member
              </th>
              <th className="text-left pl-6 text-sm text-[#24211D]">Role</th>
              <th className="text-center pl-6 text-sm text-[#24211D]">
                Action
              </th>
            </tr>
          </thead>
          {members.length > 0 && (
            <tbody>
              {members.map((member, index) => (
                <tr key={index}>
                  <td className=" justify-start flex items-center gap-3 text-sm text-[#787878] py-3 pl-6">
                    <p className="text-left text-xs bg-red-500 text-white capitalize rounded-full h-6 w-6 flex items-center justify-center ">
                      {member?.username?.split(/\W+/).length > 1
                        ? member?.username?.split(" ")[0][0] +
                          member?.username?.split(" ")[1][0]
                        : member?.username?.split(" ")[0][0]}
                    </p>
                    <p className="text-left text-sm text-[#787878]">
                      {member.username}
                    </p>
                  </td>
                  <td className="text-left text-sm text-[#787878] py-3 capitalize pl-6">
                    <select
                      onChange={(e) => {
                        const value = e.target.value;

                        console.log(value);
                        setSelectedUserAndRole({
                          ...member,
                          newRole: value,
                        });
                      }}
                      value={member.role}
                      className="rounded text-xs"
                    >
                      <option value="admin">Admin</option>
                      <option value="agent">Agent</option>
                      <option value="customer-support">Customer support</option>
                    </select>
                  </td>
                  <td className="text-center text-sm text-[#787878] py-3 pl-6">
                    <button
                      onClick={() => {
                        setRemoveModal(true);
                        setMemberToRemove(member);
                        // setOpen(true);
                      }}
                      className="bg-[#ff00001a] text-[#ff0000] transition-all hover:bg-[#ff0000] hover:text-white rounded py-1 px-3"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>

        {members.length < 1 && (
          <div className="flex my-9 items-center justify-center flex-col w-full">
            <img src={require("../../../../assets/images/noData.svg")} alt="" />
            <button
              onClick={() => {
                setRemoveModal(false);
                setOpen(true);
              }}
              className="mt-3 text-[#3989DD] underline text-sm"
            >
              Invite members
            </button>
          </div>
        )}
      </div>

      <InviteMember
        getMembers={getCampaignMembers}
        loading={loading}
        onClose={onClose}
        setLoading={setLoading}
        show={open}
      />

      {/* remove/delete member */}
      <UpdateMemberRole
        onClose={onClose}
        selectedMember={selectedUserAndRole}
        setSelectedMember={setSelectedUserAndRole}
        show={Boolean(selectedUserAndRole)}
        getCampaignMembers={getCampaignMembers}
      />
      <RemoveMember
        onClose={onClose}
        handleRemoveMember={handleRemoveMember}
        memberToRemove={memberToRemove}
        removingMember={removingMember}
        show={removeModal}
      />
    </div>
  );
};

export default Roles;
